<div
  *ngIf="invitations.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header">
  <table
    mat-table
    [dataSource]="invitations"
    class="sp-width__full">
    <ng-container matColumnDef="company_business_name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PENDING_INVITATIONS.COMPANY_BUSINESS_NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let invitation">
        <span class="sp-color__primary sp-text__ellipsized"> {{ invitation.company_business_name || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="company_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PENDING_INVITATIONS.COMPANY_ID_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let invitation">
        <app-shared-id
          [content]="invitation.company_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <

    <ng-container matColumnDef="sender_email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PENDING_INVITATIONS.SENDER_EMAIL_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let invitation">
        <span class="sp-color__primary sp-text__ellipsized"> {{ invitation.sender_email || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="recipient_email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PENDING_INVITATIONS.RECIPIENT_EMAIL_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let invitation">
        <span class="sp-color__primary sp-text__ellipsized"> {{ invitation.recipient_email || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="recipient_role">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PENDING_INVITATIONS.RECIPIENT_ROLE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let invitation">
        <app-shared-pill
          style="display: inline-block"
          [content]="getRoleLabel(invitation.recipient_role)"
          [pill_class]="getRoleClass(invitation.recipient_role)"></app-shared-pill>
      </td>
    </ng-container>

    <ng-container matColumnDef="stores">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PENDING_INVITATIONS.STORES_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let invitation">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ getStoresNames(invitation) || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PENDING_INVITATIONS.CREATED_AT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let invitation">
        <span class="sp-color__primary sp-text__ellipsized"> {{ invitation.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"></tr>
  </table>
</div>
